import React, { useState, useCallback, useEffect } from "react";
import { SectionsCard } from "./SectionsCard";
import update from "immutability-helper";
import { v4 as uuidv4 } from "uuid";


export const SectionDragAndDropContainer = ({ sectionList, internalOnChange, onChangeMasterUpdate }) => {
	const [ cards, setCards ] = useState(sectionList);

	const removeCard = index => {
		let updatedSectionList = [ ...cards ];
		updatedSectionList.splice(index, 1);
		setCards(updatedSectionList);
		onChangeMasterUpdate(updatedSectionList);
	};

	const addCard = () => {
		let updatedSection = [ ...cards ];
		updatedSection.push({ id: uuidv4(), text: "" });
		setCards(updatedSection);
		internalOnChange(updatedSection);
	};

	const moveCard = useCallback(
		(dragIndex, hoverIndex) => {
			const dragCard = cards[dragIndex];
			setCards(
				update(cards, {
					$splice: [
						[ dragIndex, 1 ],
						[ hoverIndex, 0, dragCard ],
					],
				}),
			);
		},
		[ cards ],
	);

	const cardTextOnChange = (text, index) => {
		let tempCards = [ ...cards ];
		tempCards[index].text = text;
		setCards(tempCards);
		internalOnChange(cards);
	};

	useEffect(() => {
		internalOnChange(cards);
	});

	return (
		<>
			{cards.map((card, k) => (
				<SectionsCard
					key={card.id}
					index={k}
					id={card.id}
					text={card.text}
					moveCard={moveCard}
					size={cards.length}
					addCard={addCard}
					removeCard={removeCard}
					cardTextOnChange={cardTextOnChange}
				/>
			))}
		</>
	);
};



